import { z } from "zod";

const cursor = z.string().min(1);

export const matterPhaseStreamFrameSchema = z.discriminatedUnion("type", [
  z.object({ type: z.literal("stream.ready"), headCursor: cursor }).strict(),
  z
    .object({ type: z.literal("stream.heartbeat"), headCursor: cursor })
    .strict(),
  z
    .object({
      type: z.literal("matter.phases_changed"),
      cursor,
      matterId: z.string().min(1),
      operation: z.string().min(1),
    })
    .strict(),
  z
    .object({
      type: z.literal("stream.resync_required"),
      reason: z.string().min(1),
    })
    .strict(),
  z.object({ type: z.literal("stream.shutdown") }).strict(),
]);

export type MatterPhaseStreamFrame = z.infer<
  typeof matterPhaseStreamFrameSchema
>;

export type MatterPhaseChangeFrame = Extract<
  MatterPhaseStreamFrame,
  { type: "matter.phases_changed" }
>;
